export const formataQtdEtiqueta = (qtd: number, decimal = 3): string => {
  const formattedQtd = qtd.toFixed(decimal);

  const finalQtd = formattedQtd
    .replace('.', ',')
    .replace(/(\.\d*|[^.]\d*)$/, (match) => match + '000'.slice(match.length));

  return finalQtd;
};
